import { batch, Signal, signal } from '@preact/signals-react';
import { injectable } from 'inversify';

import { ProfileLoadingState, ProfileState } from '@vp/profile/core/interface/ProfileState';
import { ProfileAccessModel } from '@vp/profile/core/model/ProfileAccessModel';
import { ProfileModel } from '@vp/profile/core/model/ProfileModel';

import { ProfileLiveMediaModel } from '../core/model/ProfileLiveMediaModel';
import { ProfilePhotoType } from '../core/model/ProfilePhotoModel';

@injectable()
export class SignalsProfileState implements ProfileState {
  readonly profile: Signal<ProfileModel> = signal({
    id: '',
    name: '',
    birthDate: '',
    deathDate: '',
    image: { id: '', hash: '', url: '', type: ProfilePhotoType.Static },
    bio: '',
    events: [],
    photos: [],
    videos: [],
    honorRecords: [],
    theme: { color: null, mode: 'dark' },
    slideshowAudio: '',
    active: true,
    premium: false,
    access: new ProfileAccessModel(),
    liveMedia: new ProfileLiveMediaModel({
      photosUsageCounter: 0,
      profileImageUsageCounter: 0,
      maxPhotosCount: 0,
      maxProfileImageCount: 0,
    } as ProfileLiveMediaModel),
  });

  readonly profileForActivation: Signal<string | null> = signal(null);
  readonly loadingState: Signal<ProfileLoadingState> = signal('loading');

  loading(): void {
    this.loadingState.value = 'loading';
  }

  success(profile: ProfileModel): void {
    batch(() => {
      this.profile.value = profile;
      this.loadingState.value = 'success';
    });
  }

  error(): void {
    this.loadingState.value = 'error';
  }

  setProfile(profile: ProfileModel): void {
    this.profile.value = profile;
  }

  storeProfileForActivation(id: string): void {
    this.profileForActivation.value = id;
  }

  resetProfileForActivation(): void {
    this.profileForActivation.value = null;
  }
}
